import React from 'react';
import { useSelector } from 'react-redux';
import {
  useLoadRows_LEGACY,
  useLoadRowsCount_LEGACY,
} from '@/features/query-builder/hooks/LEGACY';
import { selectQueryExecutionTime } from '@/features/query-builder/queryBuilderSlice';
import flex from '@/css/module/flex.css';

export const ResultsInfo = () => {
  const { rowCount } = useLoadRows_LEGACY();
  const totalRowCount = useLoadRowsCount_LEGACY();
  const timerCount = useSelector(selectQueryExecutionTime);

  return (
    <span className={flex.alignItemsCenter}>
      <span>Returned</span>
      &nbsp;
      <span className={flex.alignItemsCenter}>
        {totalRowCount !== null ? rowCount : '...'}
      </span>
      &nbsp;
      <span>
        of {totalRowCount !== null ? totalRowCount : '...'} results in{' '}
        {rowCount !== null && timerCount !== null && timerCount !== ''
          ? `${timerCount}s`
          : '...'}
      </span>
    </span>
  );
};
